<p-table [value]="deals" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="req.pageSize"
    [first]="req.page" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" lazy="true" [totalRecords]="total"
    (onLazyLoad)="loadDealsLazy($event)" [scrollable]="true" scrollHeight="flex"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template #header>
        <tr>
            <th>Deal Id</th>
            <th>iHost Id</th>
            <th>Amount</th>
            <th>Customer</th>
            <th>VAT</th>
            <th>Overdue Category</th>
            <th>Cut-off Date</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template #body let-deal>
        <tr>
            <td><a [href]="'/deals/edit/' + deal.crmid">{{ deal.crmid }}</a></td>

            <td>{{ deal.customer.ihostid }}</td>
            <td>{{ deal.value }}</td>
            <td>{{ deal.customer.name }}</td>
            <td>{{ deal.customer.vatNumber }}</td>
            <td>{{ deal.overdueInfo?.overdueCategory | overdueCategory }}</td>
            <td>{{ deal.overdueInfo?.stopAccessCutoffDate | date: 'dd/MM/yyyy hh:mm' }}</td>
            <td>
                <a [href]="'/deals/edit/' + deal.crmid">
                    <i class="pi pi-eye" style="color: slateblue"></i>
                </a>
            </td>
        </tr>
    </ng-template>
</p-table>